import { render, staticRenderFns } from "./ScreenConsultaGinecologica.vue?vue&type=template&id=6cb899d8&scoped=true&"
import script from "./ScreenConsultaGinecologica.vue?vue&type=script&lang=js&"
export * from "./ScreenConsultaGinecologica.vue?vue&type=script&lang=js&"
import style0 from "./ScreenConsultaGinecologica.vue?vue&type=style&index=0&id=6cb899d8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6cb899d8",
  null
  
)

export default component.exports